import React, { useState, useEffect } from "react";

// Material UI
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import HighlightOffIcon from '@mui/icons-material/HighlightOff';

// Components
import Upload from '../../../../../../components/inputs/upload';
import Textfield from "../../../../../../components/inputs/input";
import AutoComplete from '../../../../../../components/inputs/Autocomplete';

// Models
import { utils } from "../../../../../../utils/utils";
import { useBankAccounts } from "../../../../../../hooks/bankAccounts/useBankAccounts";


const Deposit = ({ totals, movement, setMovement }) => {
  const [previewImageUrl, setPreviewImageUrl] = useState('');
  const { bankAccounts, loading: loadingAccounts } = useBankAccounts({ active: true });

  useEffect(() => {
    setMovement(state => ({
      ...state,
      currency: movement?.bankAccount?.currency || null
    }))
  }, [setMovement, movement?.bankAccount])

  const handleValueChange = (event) =>
    setMovement({
      ...movement,
      [event.target.name]: event.target.value,
    });

  const handleChangeAutocomplete = (value) =>
    setMovement({
      ...movement,
      bankAccountInfo: `(${value?.code}) ${value?.description} - ${value?.number}`,
      bankAccountId: value.id,
      bankAccount: value
    });


  const handleFileUpload = (event) => {
    setPreviewImageUrl(URL.createObjectURL(event.target.files[0]));
    setMovement({ ...movement, files: [event.target.files[0]] })
  }

  const handleFileRemove = () => {
    setPreviewImageUrl('');
    setMovement({ ...movement, files: [] })
  }

  const GetCashTotal = () =>
    totals?.[`Cash${movement.currency}`]?.total || 0;

  return (
    <Grid container spacing={1}>
      <Grid size={12}>
        <AutoComplete
          fullWidth
          disableClearable
          disabled={loadingAccounts}
          loading={loadingAccounts}
          onChange={(e, value) => handleChangeAutocomplete(value)}
          options={bankAccounts}
          value={movement?.bankAccount || ''}
          getOptionLabel={(option) => option.id ? `(${option?.code}) ${option?.description} - ${option?.number}` : ''}
          renderOption={(props, option) => option.id ? <li {...props}><span>({option?.code}) {option?.description} - {option?.number}</span></li> : ''}
          TextProps={{
            label: 'Seleccionar cuenta',
            required: true,
          }}
        />
      </Grid>
      <Grid size={3}>
        <Textfield
          fullWidth
          disabled
          size="small"
          name="currency"
          label="Moneda"
          value={movement?.bankAccount?.currency || ''}
        />
      </Grid>
      <Grid size={9}>
        <Textfield
          fullWidth
          size="small"
          name="amount"
          label="Monto a depositar"
          type="number"
          onChange={handleValueChange}
          value={movement?.amount || ""}
        />
      </Grid>
      <Grid size={2}>
        <Textfield
          fullWidth
          size="small"
          name="externalPrefix"
          label="Prefijo"
          type="number"
          onChange={handleValueChange}
          value={movement?.externalPrefix || ""}
        />
      </Grid>
      <Grid size={4}>
        <Textfield
          fullWidth
          size="small"
          name="externaNumber"
          label="Numero Externo"
          type="number"
          onChange={handleValueChange}
          value={movement?.externaNumber || ""}
        />
      </Grid>
      <Grid size={6}>
        <Textfield
          fullWidth
          size='small'
          name="externaDate"
          label="Fecha externo"
          type="date"
          value={movement?.externaDate || ''}
          onChange={handleValueChange}
          InputLabelProps={{
            shrink: true,
          }}
        />
      </Grid>
      <Grid size={12}>
        <Textfield
          fullWidth
          multiline
          rows={5}
          size="small"
          name="observation"
          label="Observación"
          onChange={handleValueChange}
          value={movement?.observation || ""}
        />
      </Grid>
      <Grid size={12}>
        <Box display='flex' alignItems='center'>
          <Upload
            hideLegend
            id="files-upload"
            accept=".jpg,.png,.jpeg,.bmp"
            text="Adjuntar Factura o Ticket"
            onChange={handleFileUpload}
            permittedExtensions={["image/png", "image/jpg", "image/jpeg", "image/bmp"]}
            fileLength={2}
          />
          {
            previewImageUrl &&
            <div style={{ marginLeft: "10px", height: "63px", display: "flex", alignItems: "center" }}>
              <HighlightOffIcon onClick={handleFileRemove} />
              <img src={previewImageUrl} style={{ maxHeight: "50px", maxWidth: "50px", marginLeft: "5px" }} alt="" />
            </div>
          }
        </Box>
      </Grid>
      <Grid size={12}>
        <Box display="flex" justifyContent='flex-end'>
          <Typography color="primary" variant="body1" gutterBottom>
            Importe en efectivo:&nbsp;
          </Typography>
          <Typography variant="body1">
            <strong>{utils.formatMoney(GetCashTotal())}</strong>
          </Typography>
        </Box>
        <Box display="flex" justifyContent='flex-end'>
          <Typography color="primary" variant="body1" gutterBottom>
            Saldo restante:&nbsp;
          </Typography>
          <Typography variant="body1">
            <strong>
              {utils.formatMoney(GetCashTotal() - movement?.amount || 0)}
            </strong>
          </Typography>
        </Box>
      </Grid>
    </Grid>
  );
};

export default Deposit;
